module.exports = __webpack_public_path__ + "img/sidebar.7e8c9d6b.png";